import * as React from 'react';
import * as styles from './BlurContainer.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BlurContainer = function BlurContainer(_ref) {
  var background = _ref.background,
      children = _ref.children,
      enabled = _ref.enabled;

  if (!enabled || !background) {
    return children;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['blur'],
      style: {
        backgroundImage: "url(".concat(background)
      }
    }), children]
  });
};